export var E_GENDER;
(function (E_GENDER) {
    E_GENDER["MALE"] = "male";
    E_GENDER["FEMALE"] = "female";
    E_GENDER["OTHER"] = "other";
    E_GENDER["UNDEFINED"] = "undefined";
})(E_GENDER || (E_GENDER = {}));
export var E_MODAL_TASK_NAME;
(function (E_MODAL_TASK_NAME) {
    E_MODAL_TASK_NAME["AGENCY_ASSIGNMENT_MODAL"] = "AgencyAssignmentModal";
    E_MODAL_TASK_NAME["CASE_ABORT_MODAL"] = "CaseAbortModal";
    E_MODAL_TASK_NAME["EXTERNAL_COMMENTS_MODAL"] = "ExternalCommentsModal";
    E_MODAL_TASK_NAME["IDENTITY_ACCEPTED_MODAL"] = "IdentityAcceptedModal";
    E_MODAL_TASK_NAME["IDENTITY_INCOMPLETE_MODAL"] = "IdentityIncompleteModal";
    E_MODAL_TASK_NAME["IDENTITY_INVALID_MODAL"] = "IdentityRefusedModal";
    E_MODAL_TASK_NAME["ONE_TIME_REDIRECTION"] = "OneTimeRedirection";
    E_MODAL_TASK_NAME["RESEND_RECONNECTION_LINK_MODAL"] = "ResendReconnectionLinkModal";
})(E_MODAL_TASK_NAME || (E_MODAL_TASK_NAME = {}));
export var E_REQUIRED_ELEMENT_CHALLENGE_STATUS;
(function (E_REQUIRED_ELEMENT_CHALLENGE_STATUS) {
    E_REQUIRED_ELEMENT_CHALLENGE_STATUS["DISCONNECTED"] = "disconnected";
    E_REQUIRED_ELEMENT_CHALLENGE_STATUS["FAILED"] = "failed";
    E_REQUIRED_ELEMENT_CHALLENGE_STATUS["SUCCEEDED"] = "succeeded";
    E_REQUIRED_ELEMENT_CHALLENGE_STATUS["TIMED_OUT"] = "timed_out";
})(E_REQUIRED_ELEMENT_CHALLENGE_STATUS || (E_REQUIRED_ELEMENT_CHALLENGE_STATUS = {}));
export var E_QPC_REQUIRED_ELEMENT_TYPE;
(function (E_QPC_REQUIRED_ELEMENT_TYPE) {
    E_QPC_REQUIRED_ELEMENT_TYPE["LIVENESS"] = "liveness";
    E_QPC_REQUIRED_ELEMENT_TYPE["UPLOAD"] = "upload";
    E_QPC_REQUIRED_ELEMENT_TYPE["SCANID"] = "scanid";
    E_QPC_REQUIRED_ELEMENT_TYPE["DIGITAL_ID"] = "digitalid";
    E_QPC_REQUIRED_ELEMENT_TYPE["OPEN_BANKING"] = "openBanking";
    E_QPC_REQUIRED_ELEMENT_TYPE["NFC"] = "nfc";
})(E_QPC_REQUIRED_ELEMENT_TYPE || (E_QPC_REQUIRED_ELEMENT_TYPE = {}));
export var E_QPC_VERIFICATION_TYPE;
(function (E_QPC_VERIFICATION_TYPE) {
    E_QPC_VERIFICATION_TYPE["FACEMATCH"] = "facematch";
    E_QPC_VERIFICATION_TYPE["SEPA_MAIL"] = "sepamail";
})(E_QPC_VERIFICATION_TYPE || (E_QPC_VERIFICATION_TYPE = {}));
export var E_STUDY_ELEMENT_TYPE;
(function (E_STUDY_ELEMENT_TYPE) {
    E_STUDY_ELEMENT_TYPE["REQUIRED_ELEMENT"] = "required-element";
    E_STUDY_ELEMENT_TYPE["FACEMATCH"] = "facematch";
})(E_STUDY_ELEMENT_TYPE || (E_STUDY_ELEMENT_TYPE = {}));
